import { MatIconModule } from '@angular/material/icon';

export const ReadOnlyMaterialModules = [MatIconModule];
